import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getSelectedRangeOption
} from "../../../utils/date-range-options";
import {
  SET_LOADING,
  SET_TABLE_DATA_LOADING,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_DATA_POINTS_LOADING,
  SET_HEAT_MAP_LOADING,
  SET_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_CHART_SUCCESS,
  FETCH_TABLE_DATA_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_GRAPH_SUCCESS,
  FETCH_DATA_POINTS_SUCCESS,
  UPDATE_GROUP_BY_FILTER,
  UPDATE_CUSTOM_RANGE,
  UPDATE_MEMBERSHIP_TYPE_FILTER,
  UPDATE_DATES,
  UPDATE_PERIOD_TYPE_SELECTED,
  YEAR_OVER_YEAR_LOADING,
  CHANGE_PERCENTAGE_TOGGLE
} from "./checkInSaga";

export const initialState = {
  currentUser: {},
  numberOfMonths: null,
  graphData: {},
  series: [],
  isLoading: true,
  updatesLoading: false,
  modalTableData: {},
  tableDataLoading: true,
  filtersDirty: false,
  selectedRequestDates: {},
  yearOverYearLoading: true,
  selectedFilters: {
    membership_types: [],
    period_type: {
      id: 2,
      name: "Weekly"
    },
    group_by: { id: "not_grouped", name: "Not Grouped" },
    show_percentage: false
  },
  dataPoints: [],
  filters: {
    membership_types: [],
    group_by: [
      { id: "not_grouped", name: "Not Grouped" },
      { id: "day_of_the_week", name: "Group by Day of the Week" },
      { id: "time_of_day", name: "Group by Time of Day" }
    ],
    period_type: [
      {
        id: 1,
        name: "Daily"
      },
      {
        id: 2,
        name: "Weekly"
      },
      {
        id: 3,
        name: "Monthly"
      },
      {
        id: 4,
        name: "Yearly"
      }
    ]
  },
  selectedRangeOption: {},
  rangeOptions: [],
  groupByWeekDay: false,
  showPercentageToggle: true,
  showCheckInPrevPeriod: true,
  groupByTimeOfDay: false
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_DATA_POINTS_LOADING]: (state, action) => ({
      ...state,
      isDataPointsLoading: action.payload
    }),
    [SET_HEAT_MAP_LOADING]: (state, action) => ({
      ...state,
      isHeatMapLoading: action.payload
    }),
    [YEAR_OVER_YEAR_LOADING]: (state, action) => ({
      ...state,
      yearOverYearLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload,
      rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [UPDATE_GROUP_BY_FILTER]: (state, action) => {
      const isNotGroupedSelected = action.payload.id === "not_grouped";

      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          group_by: action.payload,
          show_percentage: isNotGroupedSelected ? state.selectedFilters.show_percentage : false
        },
        showPercentageToggle: isNotGroupedSelected
      };
    },
    [SET_TABLE_DATA_LOADING]: (state, action) => ({
      ...state,
      tableDataLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload.currentUser || state.currentUser,
      numberOfMonths: action.payload.numberOfMonths || state.numberOfMonths,
      selectedFilters: {
        ...state.selectedFilters,
        group_by: initialState.selectedFilters.group_by,
        show_percentage: false
      },
      groupByTimeOfDay: false,
      showPercentageToggle: initialState.showPercentageToggle,
      showCheckInPrevPeriod: true
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      series: action.payload || state.series,
      groupByTimeOfDay: state.selectedFilters.group_by.id === "time_of_day",
      showCheckInPrevPeriod: state.selectedFilters.group_by.id === "not_grouped"
    }),
    [FETCH_GRAPH_SUCCESS]: (state, action) => ({
      ...state,
      graphData: action.payload || state.graphData,

      yearOverYearLoading: false
    }),
    [FETCH_DATA_POINTS_SUCCESS]: (state, action) => ({
      ...state,
      dataPoints: action.payload
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      modalTableData: action.payload.tableInfo || state.modalTableData,
      tableDataLoading: false
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: { ...state.filters, membership_types: action.payload.membership_types },
      selectedFilters: {
        ...initialState.selectedFilters,
        membership_types: action.payload.membership_types
      }
    }),
    [UPDATE_MEMBERSHIP_TYPE_FILTER]: (state, { payload }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, membership_types: payload }
    }),
    [UPDATE_PERIOD_TYPE_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: { ...state.selectedFilters, period_type: action.payload }
    }),
    [CHANGE_PERCENTAGE_TOGGLE]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        show_percentage: action.payload
      }
    })
  },
  initialState
);
